import api from "api/axios";

const master = (path) => ({
  list: (params) => api.get(`/immunization/${path}`, { params }),
  active: (params) => api.get(`/immunization/${path}/active`, { params }),
  byId: (id) => api.get(`/immunization/${path}/${id}`),
  create: (payload) => api.post(`/immunization/${path}`, payload),
  update: (id, payload) => api.put(`/immunization/${path}/${id}`, payload),
  setLifecycle: (id, payload) =>
    api.patch(`/immunization/${path}/${id}/lifecycle`, payload),
});

export const antigenApi = master("antigen");
export const vaccineProductApi = master("product");
export const scheduleApi = master("schedule");
export const contraindicationApi = master("contraindication");
export const riskCohortApi = master("risk-cohort");

export const presentationApi = master("presentation");
export const administrationRouteApi = master("administration-route");
export const administrationSiteApi = master("administration-site");
export const fundingSourceApi = master("funding-source");
export const vaccinationOutcomeReasonApi = master("outcome-reason");
export const coverageMetricApi = master("coverage-metric");
